import React, { useState } from "react";
import "./AddAds.css";
import { createAds } from "../../api/adsApi";
import toast from "react-hot-toast";

export default function AddAds({ open, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    adsType: "native",
    timePeriodInMins: "",
    adsCount: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      adsType: formData.adsType,
      timePeriodInMins: Number(formData.timePeriodInMins),
      adsCount: Number(formData.adsCount),
    };

    console.log("Ads Payload:", payload);
    const res = await createAds(payload);
    // API CALL HERE
    // const res = await createAds(payload);
    if (res.success) {
      if (onSuccess) onSuccess();
      if (onClose) onClose();
      toast.success("New Ads created.");
    }
  };

  if (!open) return;

  return (
    <div className="ads-modal-overlay">
      <div className="ads-modal">
        <div className="ads-modal-header">
          <h2>Add Ads</h2>

          <button className="close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="ads-form">
          {/* Ads Type */}
          <div className="form-group">
            <label>Ads Type</label>

            <select
              name="adsType"
              value={formData.adsType}
              onChange={handleChange}
            >
              <option value="native">Native</option>
              <option value="interstitial">Interstitial</option>
              <option value="reward">Reward</option>
            </select>
          </div>

          {/* Time Period */}
          <div className="form-group">
            <label>Time Period (Minutes)</label>

            <input
              type="number"
              name="timePeriodInMins"
              placeholder="Enter time interval"
              value={formData.timePeriodInMins}
              onChange={handleChange}
              min={1}
              required
            />
          </div>

          {/* Ads Count */}
          <div className="form-group">
            <label>Ads Count</label>

            <input
              type="number"
              name="adsCount"
              placeholder="Enter ads count"
              value={formData.adsCount}
              onChange={handleChange}
              min={1}
              required
            />
          </div>

          {/* Buttons */}
          <div className="modal-actions">
            <button type="button" className="cancel-btn" onClick={onClose}>
              Cancel
            </button>

            <button type="submit" className="add-btn">
              Add Ads
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
